'use client'
import React from 'react'
import Content from '../../_utilities/data/sections/digital-service.json'
import Link from 'next/link'
import Image from 'next/image'

interface DigitalServiceItem {
  [x: string]: string
  image: string
  name: string
  text: string
}

const DigitalService: React.FC = () => {
  const awardsItems: DigitalServiceItem[] = []
  Content.items.forEach((item, index) => {
    let itemClass = 'mil-awards-dig-box mil-gradient-bg'
    if ((index + 1) % 2 == 0) {
      itemClass += ' mil-box-2'
    }
    if (index == Content.items.length - 1) {
      itemClass += ' mil-pb-60-adapt'
    }
    let newobj = Object.assign({}, item, { boxClass: itemClass })
    awardsItems.push(newobj as DigitalServiceItem)
  })
  return (
    <>
      <section className="mil-p mt-5" style={{marginBottom:"35px"}}>
        <div className="container">
          <div className="row">
            <div className=" text-justify">
              <h2 className="mil-mb-5 mil-h2">
                All <span className="mil-accent">Services</span> In One Place
              </h2>
              <p className="mil-dig-text" style={{ textAlign: 'justify' }}>
                We are Pyther Innovations, where innovation meets expertise in software development.
                Our skilled team specializes in crafting visually stunning and highly functional web
                applications using ReactJS, Vue JS, and Next.js, as well as transforming ideas into
                reality through mobile app development on iOS, Android, and React Native. From IoT
                development to Salesforce integration, our tailored eCommerce solutions, along with
                our custom software development services, ensure a seamless digital experience.
                Leveraging AWS for connected IoT solutions, we bring scalability and efficiency to
                the forefront. With proficiency in Java, J2EE, PHP, and NodeJS, we turning unique
                visions into digital realities. At Pyther, we don't just develop software; we create
                impactful digital experiences – your success, our mission.{' '}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="mil-awards">
        <div className="row m-0">
          <div className="col-xl-12 p-0 m-auto product-card">
            <div className="row m-0">
              {awardsItems.map((item, index) => (
                <div key={index} className="col-md-6 col-xl-4 col-xxl-4 p-0 mil-service" style={{border:"0.1px outset black"}}>
                  <div className="mil-hover-card mil-box-center" style={{ padding: '0px' }}>
                    <div className="mil-deco mil-deco-accent" style={{ right: '-10%' }} />
                  

                    {item.image && (
                      <div className={item.boxClass}>
                        <div className="mil-icon-box mil-center">
                      {/* give anchor tag because when user click on home screen to any service it can redirect to that service */}
                          <a
                            id={`service-${index}`}
                            // href={`/services#${index}`}
                            href={`/services#${item?.link}`}
                            style={{ textDecoration: 'none' }}
                          >
                            <div className="mil-icon-frame-md mil-mb-10">
                              {/* <Image src={item.image} height={70} width={70} alt={item.link} layout="intrinsic"/> */}
                              <Image src={item.image} height={70} width={70} alt={item.link} />
                            </div>
                            <p className="mil-light mil-mb-20 mil-h5" style={{fontSize:"16px"}}>
                                {item.name}
                            </p>
                            {/* <h5 className="mil-light mil-mb-20 mil-h5" style={{fontSize:"16px"}}>{item.name}</h5> */}
                          </a>

                          <p className="mil-text-sm mil-light-soft mil-font-2" style={{ textAlign: 'justify' }} >{item.text}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default DigitalService
